import * as gfunctions from '../../../js/generalFunctions';

CCL.cheersAtcModal = {
  autoload: [
    ['modalEvents', $('#cheersAtcModal').length > 0]
  ],

  modalEvents() {
    const modalEl = $('#cheersAtcModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-cheers-atc-modal/cheers-atc-modal.js